/**
 * Performance Profile Detection
 * Détecte les capacités de l'appareil pour optimiser les performances
 */

export function getPerformanceProfile() {
    const cores = navigator.hardwareConcurrency || 0;
    const memory = navigator.deviceMemory || 0;
    const ua = navigator.userAgent || '';
    const isMobileUa = /Android|iPhone|iPad|iPod|Mobile|IEMobile|Opera Mini/i.test(ua);
    const isTouch = (navigator.maxTouchPoints || 0) > 0;
    const smallScreen = typeof window.matchMedia === 'function'
        ? window.matchMedia('(max-width: 900px)').matches
        : false;

    const lowCpu = cores > 0 && cores <= 4;
    const lowMem = memory > 0 && memory <= 4;
    const isMobile = isMobileUa || (isTouch && smallScreen);
    const lowPower = isMobile || lowCpu || lowMem;

    return {
        cores,
        memory,
        isMobile,
        lowPower
    };
}
